var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.url
    ? _c("span", [_vm._t("default")], 2)
    : _vm.isInternal
    ? _c(
        "router-link",
        { class: _vm.bemBlock, attrs: { to: _vm.relativeUrl } },
        [_vm._t("default")],
        2
      )
    : _c(
        "a",
        { class: _vm.bemBlock, attrs: { target: "_blank", href: _vm.url } },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }